import React, { ChangeEvent, useEffect, useMemo, useState } from 'react';
import {
  Box,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Tooltip,
  Typography,
  Icon,
  TableBody,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  InputAdornment,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Switch,
  FormControlLabel,
} from '@mui/material';

import { Autocomplete } from '@mui/lab';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RefreshIcon from '@mui/icons-material/Refresh';
import Axios, { Canceler } from 'axios';
import api from '../../../../services/api';
import styles from './styles';
import { ProfileField } from '../../../../components/ProfileField';

type OrderProp = 'asc' | 'desc';

interface LicenseData {
  module: string;
  max: number;
}

interface ResponseData {
  end_connection: string;
  licence?: LicenseData[];
  connections: ConnectionData[];
}

interface ConnectionData {
  id_process: string;
  pc_name_instance: string;
  user_name: string;
  process: string;
  nickname: string;
  pc_name: string;
  user_id: number;
}

const processListFilter = [
  { value: 'All', title: 'All - Flutuante' },
  { value: 'CCCT', title: 'CCCT - Controladoria - Gestão de Contabilidade - Contabilidade' },
  { value: 'CCMM', title: 'CCMM - Controladoria - Gestão de Contabilidade - Contabilidade Multimoeda' },
  { value: 'CCSP', title: 'CCSP - Controladoria - Gestão de Contabilidade - Arquivos Fiscais' },
  { value: 'CCVC', title: 'CCVC - Controladoria - Gestão de Contabilidade - Visões Contábeis' },
  { value: 'CIAF', title: 'CIAF - Controladoria - Gestão de Tributos - Arquivos Fiscais' },
  { value: 'CICI', title: 'CICI - Controladoria - Gestão de Tributos - CIAP' },
  { value: 'CIEC', title: 'CIEC - Controladoria - Gestão de Tributos - Escrituração' },
  { value: 'CIOF', title: 'CIOF - Controladoria - Gestão de Tributos - Operações e Cálculos Fiscais' },
  { value: 'CISO', title: 'CISO - Controladoria - Gestão de Tributos - EFD - Reinf' },
  { value: 'CPAT', title: 'CPAT - Controladoria - Gestão de Patrimônio - Atualização Patrimonial' },
  { value: 'CPBE', title: 'CPBE - Controladoria - Gestão de Patrimônio - Controle dos Bens' },
  { value: 'CPIV', title: 'CPIV - Controladoria - Gestão de Patrimônio - Inventário Patrimonial' },
  {
    value: 'EMDC',
    title:
      'EMDC - Integrações (com sistemas externos) - Integrações Proprietárias - eDocs - Múltiplos Documentos com NFS-e',
  },
  { value: 'FFCC', title: 'FFCC - Finanças - Gestão de Plano Financeiro - Controle de Contas Financeiras' },
  { value: 'FFFC', title: 'FFFC - Finanças - Gestão de Plano Financeiro - Fluxo de Caixa Gerencial' },
  { value: 'FFOR', title: 'FFOR - Finanças - Gestão de Plano Financeiro - Orçamentos' },
  { value: 'FJCF', title: 'FJCF - Finanças - Gestão Orçamentária e Projetos - Controle Financeiro' },
  { value: 'FJFS', title: 'FJFS - Finanças - Gestão Orçamentária e Projetos - Controle Físico' },
  { value: 'FJPO', title: 'FJPO - Finanças - Gestão Orçamentária e Projetos - Preparação de Orçamento' },
  { value: 'FPCP', title: 'FPCP - Finanças - Gestão de Contas a Pagar - Contas a Pagar' },
  { value: 'FPMI', title: 'FPMI - Finanças - Gestão de Contas a Pagar - Comissões' },
  { value: 'FPPE', title: 'FPPE - Finanças - Gestão de Contas a Pagar - Pagamento Eletrônico' },
  { value: 'FRCR', title: 'FRCR - Finanças - Gestão de Contas a Receber - Contas a Receber' },
  { value: 'FRES', title: 'FRES - Finanças - Gestão de Contas a Receber - Cobrança Escritural' },
  { value: 'FTAF', title: 'FTAF - Finanças - Gestão de Tesouraria - Aplicação e Financiamento' },
  { value: 'FTCB', title: 'FTCB - Finanças - Gestão de Tesouraria - Caixa e Bancos' },
  { value: 'FTFC', title: 'FTFC - Finanças - Gestão de Tesouraria - Fluxo de Caixa' },
  { value: 'FTON', title: 'FTON - Finanças - Gestão de Tesouraria - Conciliação' },
  { value: 'MCAP', title: 'MCAP - Manufatura - Gestão de Chão de Fábrica - Apontamentos de OP/OS' },
  { value: 'MCCO', title: 'MCCO - Manufatura - Gestão de Chão de Fábrica - Componentes (OP/OS)' },
  { value: 'MCMM', title: 'MCMM - Manufatura - Gestão de Chão de Fábrica - Manutenção de Movimentos' },
  { value: 'MCRR', title: 'MCRR - Manufatura - Gestão de Chão de Fábrica - Remessa/Retorno Serviço Terceiros' },
  { value: 'MCSS', title: 'MCSS - Manufatura - Gestão de Chão de Fábrica - Separação de Componentes Depósito' },
  { value: 'MEBI', title: 'MEBI - Manufatura - Gestão de Engenharia de Produto/Serviço - Combinações' },
  {
    value: 'MECO',
    title: 'MECO - Manufatura - Gestão de Engenharia de Produto/Serviço - Composição Produto/Serviço (Modelo)',
  },
  {
    value: 'MEDU',
    title: 'MEDU - Manufatura - Gestão de Engenharia de Produto/Serviço - Duplicação de Roteiro/Modelo',
  },
  { value: 'MERP', title: 'MERP - Manufatura - Gestão de Engenharia de Produto/Serviço - Roteiro de Produção' },
  { value: 'MPAD', title: 'MPAD - Manufatura - Gestão de PCP - Análise de Disponibilidade de Componentes' },
  { value: 'MPCR', title: 'MPCR - Manufatura - Gestão de PCP - Carga de Recursos da Produção' },
  { value: 'MPLP', title: 'MPLP - Manufatura - Gestão de PCP - Cancelamento de Produção' },
  { value: 'MPMO', title: 'MPMO - Manufatura - Gestão de PCP - Manutenção de OP/OS' },
  { value: 'MPNE', title: 'MPNE - Manufatura - Gestão de PCP - Necessidades de Produção/Compra (MRP)' },
  { value: 'MPOP', title: 'MPOP - Manufatura - Gestão de PCP - Ordens de Produção/Serviço' },
  { value: 'QQAF', title: 'QQAF - Qualidade - Gestão de Qualidade (SGQ) - Avaliação de Fornecedores' },
  { value: 'QQDC', title: 'QQDC - Qualidade - Gestão de Qualidade (SGQ) - Controle de Documentos' },
  { value: 'QQIN', title: 'QQIN - Qualidade - Gestão de Qualidade (SGQ) - Inspeções' },
  { value: 'QQRG', title: 'QQRG - Qualidade - Gestão de Qualidade (SGQ) - Registros' },
  { value: 'RDAC', title: 'RDAC - Mercado - Gestão de Distribuição - Acertos' },
  { value: 'RDCG', title: 'RDCG - Mercado - Gestão de Distribuição - Cargas' },
  { value: 'RFEX', title: 'RFEX - Mercado - Gestão de Faturamento e Outras Saídas - Expedição' },
  { value: 'RFNF', title: 'RFNF - Mercado - Gestão de Faturamento e Outras Saídas - Notas Fiscais de Saída' },
  { value: 'RFSB', title: 'RFSB - Mercado - Gestão de Faturamento e Outras Saídas - Saída via Balança' },
  { value: 'RRCA', title: 'RRCA - Mercado - Gestão de Relacionamento (CRM) - Controle de Atendimento' },
  { value: 'RTTR', title: 'RTTR - Mercado - Gestão de Transporte (TMS) - Controle de Transporte' },
  { value: 'RVCM', title: 'RVCM - Mercado - Gestão de Vendas - Controle de Metas' },
  { value: 'RVOR', title: 'RVOR - Mercado - Gestão de Vendas - Orçamentos' },
  { value: 'RVPE', title: 'RVPE - Mercado - Gestão de Vendas - Pedidos' },
  { value: 'RVTR', title: 'RVTR - Mercado - Gestão de Vendas - Contratos' },
  { value: 'SAPNFE', title: 'SAPNFE - Integrações (com sistemas externos) - Integrações Proprietárias - Senior NF-e' },
  { value: 'SCCP', title: 'SCCP - Suprimentos - Gestão de Compras - Cotação de Preço' },
  { value: 'SCOC', title: 'SCOC - Suprimentos - Gestão de Compras - Ordens de Compra' },
  { value: 'SCSC', title: 'SCSC - Suprimentos - Gestão de Compras - Solicitação de Compra' },
  { value: 'SCTR', title: 'SCTR - Suprimentos - Gestão de Compras - Contratos' },
  { value: 'SEAR', title: 'SEAR - Suprimentos - Gestão de Estoques - Análise de Reposição' },
  { value: 'SECE', title: 'SECE - Suprimentos - Gestão de Estoques - Controle de Estoque' },
  { value: 'SEIV', title: 'SEIV - Suprimentos - Gestão de Estoques - Inventário' },
  { value: 'SERE', title: 'SERE - Suprimentos - Gestão de Estoques - Requisição Eletrônica' },
  { value: 'SRCP', title: 'SRCP - Suprimentos - Gestão de Recebimento - Coleta de Produtos em Fornecedores' },
  { value: 'SREB', title: 'SREB - Suprimentos - Gestão de Recebimento - Entrada via Balança' },
  { value: 'SRNF', title: 'SRNF - Suprimentos - Gestão de Recebimento - Notas Fiscais de Entrada' },
  { value: 'UCAD', title: 'UCAD - Custos - Gestão de Preço para Comércio - Análises de Desempenho' },
  { value: 'UCFP', title: 'UCFP - Custos - Gestão de Preço para Comércio - Formação de Preços' },
  { value: 'UIAD', title: 'UIAD - Custos - Gestão de Preço para Indústria - Análises de Desempenho' },
  { value: 'UIFP', title: 'UIFP - Custos - Gestão de Preço para Indústria - Formação de Preços' },
  { value: 'UTAD', title: 'UTAD - Custos - Gestão de Contabilidade de Custos - Análises de Desempenho' },
  { value: 'UTCC', title: 'UTCC - Custos - Gestão de Contabilidade de Custos - Custo Integrado' },
  { value: 'UTUA', title: 'UTUA - Custos - Gestão de Contabilidade de Custos - Custo Não Integrado' },
  { value: 'VMME', title: 'VMME - Serviços - Gestão de Manutenção - Manutenção de Equipamentos' },
  { value: 'VSEX', title: 'VSEX - Serviços - Gestão de Ordens de Serviço - Execução' },
  { value: 'VSFT', title: 'VSFT - Serviços - Gestão de Ordens de Serviço - Ficha Técnica' },
  { value: 'VSGE', title: 'VSGE - Serviços - Gestão de Ordens de Serviço - Gerenciamento' },
  { value: 'VSPJ', title: 'VSPJ - Serviços - Gestão de Ordens de Serviço - Planejamento' },
  { value: 'VSRR', title: 'VSRR - Serviços - Gestão de Ordens de Serviço - Remessa/Retorno Serviço Terceiros' },
  { value: 'WWEB', title: 'WWEB - Web - Web 5.0 - Sapiens WEB 5.0' },
  {
    value: 'XAGS',
    title:
      'XAGS - Integrações (com sistemas externos) - Integrações Proprietárias - Integração com Decision Center (App gestor)',
  },
];

export default function AdminUsersAddPage() {
  const classes = styles();
  const [orderBy] = useState('process');
  const [orderDir] = useState<OrderProp>('asc');
  const [gettingData, setGettingData] = useState(false);
  const [endingProcess, setEndingProcess] = useState(false);
  const [filterProcess, setFilterProcess] = useState('');
  const [searchText, setSearchText] = useState('');
  const [responseData, setResponseData] = useState<ResponseData>({} as ResponseData);
  const [searchBase, setSearchBase] = useState('erp');

  // Controle de expansão dos accordions
  const [expandedModules, setExpandedModules] = useState<string[]>([]);
  const [hasInitializedExpanded, setHasInitializedExpanded] = useState(false);

  // Filtro de persistência para exibir/ocultar licenças vazias
  const [showEmptyLicenses, setShowEmptyLicenses] = useState<boolean>(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('search-users-show-empty');
      return saved !== null ? saved === 'true' : true;
    }
    return true;
  });

  const handleBaseChange = (event: SelectChangeEvent) => {
    setSearchBase(event.target.value as string);
  };

  const handleSearchFieldChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  };

  const handleShowEmptyChange = (event: ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    setShowEmptyLicenses(isChecked);
    localStorage.setItem('search-users-show-empty', String(isChecked));
  };

  const getData = ({
    order_by = orderBy,
    order_dir = orderDir,
    process = filterProcess,
    user_name = '',
    search = searchText,
    base = searchBase,
  }) => {
    let cancel: Canceler;
    if (!gettingData) {
      const params = {
        order_by,
        order_dir,
        process,
        user_name,
        search,
        base,
      };
      setGettingData(true);

      api
        .get('erp/connections/', {
          params,
          cancelToken: new Axios.CancelToken(c => {
            cancel = c;
          }),
        })
        .then(response => {
          setResponseData(response?.data);
          setGettingData(false);
        })
        .catch(error => {
          console.error(error);
          setGettingData(false);
        });
    }
    return () => cancel && cancel();
  };

  const handleRefresh = () => {
    getData({ process: filterProcess, search: searchText, base: searchBase });
  };

  const handleEndConnection = async (process_id: string, base: string) => {
    if (!endingProcess) {
      try {
        setEndingProcess(true);
        await api.post(`erp/connections`, {
          process_id,
          base,
        });
        getData({});
        setEndingProcess(false);
      } catch (error) {
        console.error(error);
        setEndingProcess(false);
      }
    }
  };

  useEffect(() => {
    getData({ process: filterProcess, search: searchText, base: searchBase });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterProcess, searchText, searchBase]);

  useEffect(() => {
    if (responseData?.connections && !hasInitializedExpanded) {
      const activeModules = Array.from(new Set(responseData.connections.map(c => c.process)));
      setExpandedModules(activeModules);
      setHasInitializedExpanded(true);
    }
  }, [responseData, hasInitializedExpanded]);

  const handleAccordionToggle = (moduleKey: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    if (isExpanded) {
      setExpandedModules(prev => [...prev, moduleKey]);
    } else {
      setExpandedModules(prev => prev.filter(key => key !== moduleKey));
    }
  };

  const renderSearchTextInput = useMemo(
    () => (
      <TextField
        id="string-search"
        label="PC / Usuário"
        variant="outlined"
        size="small"
        sx={{ width: 260 }}
        onChange={handleSearchFieldChange}
        value={searchText}
        InputProps={{
          startAdornment: <InputAdornment position="start" />,
        }}
      />
    ),
    [searchText],
  );

  const renderBaseInput = useMemo(
    () => (
      <FormControl sx={{ width: 256 }}>
        <InputLabel id="base-select-label">Base</InputLabel>
        <Select
          labelId="base-select-label"
          id="base-select"
          value={searchBase}
          label="Base"
          size="small"
          onChange={handleBaseChange}
        >
          <MenuItem value="erp">Sapiens Produção</MenuItem>
          <MenuItem value="erp_dev">Sapiens Homologação</MenuItem>
          <MenuItem value="erp_old">Sapiens Antiga</MenuItem>
          <MenuItem value="hcm">HCM Produção</MenuItem>
          <MenuItem value="hcm_dev">HCM Homologação</MenuItem>
        </Select>
      </FormControl>
    ),
    [searchBase],
  );

  const renderProcessFilterSelect = useMemo(
    () => (
      <Autocomplete
        id="process-filter"
        options={processListFilter}
        getOptionLabel={(option: any) => option?.title}
        onChange={(event: ChangeEvent<{}>, newValue: { value: string; title: string } | null) => {
          setFilterProcess(`${newValue?.value ? newValue?.value : ''}`);
        }}
        value={processListFilter.find(process => process.value === filterProcess) || null}
        renderInput={params => <TextField {...params} label="Processo" variant="outlined" />}
        sx={{ flex: 1 }}
        size="small"
      />
    ),
    [filterProcess],
  );

  const renderAccordions = useMemo(() => {
    if (gettingData && !responseData?.connections) {
      return (
        <Paper className={classes.tablePaper}>
          <Box p={4} textAlign="center">
            <Typography variant="caption" className={classes.loadingInitialDataText}>
              Carregando dados...
            </Typography>
          </Box>
        </Paper>
      );
    }

    const modulesMap = new Map<string, { max: number; used: number; connections: ConnectionData[] }>();

    responseData?.licence?.forEach(lic => {
      if (lic.max > 0) {
        modulesMap.set(lic.module, { max: lic.max, used: 0, connections: [] });
      }
    });

    responseData?.connections?.forEach(conn => {
      if (!modulesMap.has(conn.process)) {
        modulesMap.set(conn.process, { max: 0, used: 0, connections: [] });
      }
      const mod = modulesMap.get(conn.process)!;
      mod.used += 1;
      mod.connections.push(conn);
    });

    const modulesToRender = Array.from(modulesMap.entries()).filter(([moduleKey, data]) => {
      if (filterProcess && filterProcess !== 'All' && moduleKey !== filterProcess) {
        return false;
      }
      if (searchText && data.connections.length === 0) {
        return false;
      }
      if (!showEmptyLicenses && data.used === 0) {
        return false;
      }
      return true;
    });

    modulesToRender.sort((a, b) => a[0].localeCompare(b[0]));

    return (
      <Box display="flex" flexDirection="column" gap={1}>
        {modulesToRender.map(([moduleKey, data]) => {
          const title = processListFilter.find(p => p.value === moduleKey)?.title || moduleKey;
          const isCritical = data.max > 0 && data.used >= data.max;
          const isExpanded = expandedModules.includes(moduleKey);

          return (
            <Accordion key={moduleKey} expanded={isExpanded} onChange={handleAccordionToggle(moduleKey)} disableGutters>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box display="flex" justifyContent="space-between" alignItems="center" width="100%" pr={2}>
                  <Typography variant="subtitle2" fontWeight="bold">
                    {title}
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    fontWeight="bold"
                    color={isCritical ? 'error.main' : data.used > 0 ? 'success.main' : 'textSecondary'}
                  >
                    {data.used}/{data.max > 0 ? data.max : '-'}
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  padding: 0,
                  bgcolor: theme => (theme.palette.mode === 'dark' ? 'background.default' : 'rgba(0, 0, 0, 0.01)'),
                }}
              >
                {data.connections.length > 0 ? (
                  <TableContainer>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          {responseData?.end_connection === '1' && (
                            <TableCell style={{ minWidth: 42, maxWidth: 42, width: 42 }} align="center" />
                          )}
                          <TableCell style={{ fontWeight: 'bold', width: 200, minWidth: 200, maxWidth: 200 }}>
                            Login
                          </TableCell>
                          <TableCell style={{ fontWeight: 'bold' }}>Usuário</TableCell>
                          <TableCell style={{ fontWeight: 'bold', width: 200, minWidth: 200, maxWidth: 200 }}>
                            PC
                          </TableCell>
                          <TableCell style={{ fontWeight: 'bold', width: 200, minWidth: 200, maxWidth: 200 }}>
                            Instância
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data.connections.map((conn, idx) => (
                          <TableRow hover key={`conn-${conn.id_process}-${idx}`}>
                            {responseData?.end_connection === '1' && (
                              <TableCell style={{ minWidth: 42, maxWidth: 42, width: 42 }} align="center">
                                <Tooltip title="Desconectar Usuário">
                                  <Button
                                    variant="outlined"
                                    color="secondary"
                                    style={{ padding: 0, minWidth: 36, width: 36, height: 36 }}
                                    onClick={() => handleEndConnection(conn.id_process, searchBase)}
                                  >
                                    <Icon fontSize="small">close</Icon>
                                  </Button>
                                </Tooltip>
                              </TableCell>
                            )}
                            <TableCell style={{ width: 200, minWidth: 200, maxWidth: 200 }}>
                              {conn.user_name?.toLowerCase()}
                            </TableCell>
                            <TableCell>
                              <ProfileField userId={conn.user_id} userName={conn.nickname} />
                            </TableCell>
                            <TableCell style={{ width: 200, minWidth: 200, maxWidth: 200 }}>
                              {conn.pc_name?.toUpperCase()}
                            </TableCell>
                            <TableCell style={{ width: 200, minWidth: 200, maxWidth: 200 }}>
                              {conn.pc_name_instance?.toUpperCase()}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <Box p={2}>
                    <Typography variant="body2" color="textSecondary">
                      Nenhuma conexão ativa neste módulo.
                    </Typography>
                  </Box>
                )}
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Box>
    );
  }, [gettingData, responseData, filterProcess, searchText, classes, searchBase, expandedModules, showEmptyLicenses]);

  return (
    <Box display="flex" gap={2} flexDirection="column">
      <Paper className={classes.tablePaper}>
        <Box p={1} pt={2} display="flex" alignItems="center" flexWrap="wrap" gap={2}>
          {renderBaseInput}
          {renderSearchTextInput}
          {renderProcessFilterSelect}
          <FormControlLabel
            control={
              <Switch checked={showEmptyLicenses} onChange={handleShowEmptyChange} color="primary" size="small" />
            }
            label={<Typography variant="body2">Mostrar vazias</Typography>}
            style={{ margin: 0 }}
          />
          <Box display="flex" alignItems="center" gap={1} ml="auto">
            <Typography variant="caption" style={{ paddingLeft: 8, width: 96, textAlign: 'center' }}>
              {`TOTAL: ${responseData?.connections?.length || 0}`}
            </Typography>
            <Tooltip title="Atualizar Dados">
              <Button
                variant="outlined"
                size="small"
                style={{ minWidth: 40, padding: 0, height: 30 }}
                onClick={handleRefresh}
              >
                <RefreshIcon fontSize="small" />
              </Button>
            </Tooltip>
            <Tooltip title="Expandir Todos">
              <Button
                variant="outlined"
                size="small"
                style={{ minWidth: 40, padding: 0, height: 30 }}
                onClick={() => setExpandedModules(processListFilter.map(p => p.value))}
              >
                <Icon fontSize="small">unfold_more</Icon>
              </Button>
            </Tooltip>
            <Tooltip title="Recolher Todos">
              <Button
                variant="outlined"
                size="small"
                style={{ minWidth: 40, padding: 0, height: 30 }}
                onClick={() => setExpandedModules([])}
              >
                <Icon fontSize="small">unfold_less</Icon>
              </Button>
            </Tooltip>
          </Box>
        </Box>
      </Paper>

      {renderAccordions}
    </Box>
  );
}
